import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';


import Tabs from "../Tabs";

import TabsPane from "../Tabs/TabsPane";

import UpgradeV1 from "./subscribe/upgradeV1";

import Invoice from "./subscribe/invoice";

class partnerSubscriptionInfov1 extends Component {

  constructor(props) {
    super(props);
    this.state = {
      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
    }
 
  }

 showMTab = (element) => {

    $('.submenu-list a').each(function () {
      $(this).removeClass('active');

    });

    $("." + element).addClass("active");
    $(".mainblock").removeClass('active').addClass('hidden');
    $("#" + element).removeClass('hidden').addClass('active');

    //document.getElementById(element).style.display = 'block';
  }

  render() {
    const { current_plan } = this.state.user_data;
    const childTabs = [
     
      {
        name: "Upgrade",
        id: "upgrade",
        defaultChecked: true
      },
      /*
      {
        name: "Renewal",
        id: "ranewal",
        disabled: true
        // disabled: (current_plan == 0) ? true : false
      },*/
      {
        name: "Invoice",
        id: "invoice",
        defaultChecked: false
      },
    ];
 
        return (
            <React.Fragment>
                <AdminLayout>
                    
              <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Subscription</h4>
                   
                  <div class="desktoponly">
                   <Tabs tabsetName="Subscribe" tabClassName="custom-tab" childTabs={childTabs}>
                   
                    <TabsPane id="upgrade">
                      <UpgradeV1 />
                    </TabsPane>
                        { /* 
                        <TabsPane id="ranewal">
                          <Renewal />
                        </TabsPane> */ 
                        }
                    <TabsPane id="invoice">
                      <Invoice />
                    </TabsPane>
                  </Tabs>
                  </div>

                  <div class="mobileonly">
                    <UpgradeV1 />
                  </div>

                </div>
              </div>

              
            </div>  


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default partnerSubscriptionInfov1;


// WEBPACK FOOTER //
// ./src/components/bewise/partners/subscriptioninfov1.jsx